/**
 * The Start Enrollment form's opening enrollment period and effective date.
 *
 * An AEP enrollment lands on the client's AEP opportunity, which the backend
 * dates Jan 1 of the plan year the cycle enrolls for (now.year + 1, see
 * crm/opportunities.py get_aep_effective_date_str) and never re-dates from the
 * form. So an AEP form shows that date, i.e. the store's `nextYear`, not
 * the page's `year`: a link's ?year= is the plan-data year (an AEP 2027
 * recommendation built on 2026 plans links year=2026).
 */

export const AEP = 'AEP'

export function aepEffectiveDate (nextYear) {
    return `${nextYear}-01-01`
}

/**
 * `ep` is the link's ?ep=; PlanCard links build it from the survey's stored
 * period, so an unset one arrives as "null"/"undefined" and is not a period.
 * An AEP recommendation (`summaryAep`) makes the enrollment AEP whatever the
 * link says, since that stored period is usually years old (IEP at turning 65).
 */
export function enrollmentDefaults ({
    ep,
    periods = [],
    summaryAep = false,
    isAEP = false,
    isSEPLEC = false,
    isSEPMoving = false,
    surveyEffectiveDate = null,
    nextYear,
}) {
    const asked = periods.includes(ep) ? ep : null
    let period
    if (asked === AEP || summaryAep) {
        period = AEP
    } else if (asked) {
        period = asked
    } else if (isAEP) {
        period = AEP
    } else if (isSEPLEC) {
        period = 'SEP_LEC'
    } else if (isSEPMoving) {
        period = 'SEP_MOVING'
    } else {
        period = null
    }
    return {
        enrollment_period: period,
        effective_date: period === AEP ? aepEffectiveDate(nextYear) : surveyEffectiveDate || null,
    }
}
